import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import {
  useGqlMutation,
  useSuspenseGqlQuery,
} from "@/lib/GraphQLCodegen/fetcher";
import { refundPaymentMutation } from "@/app/Bookings/GraphQL/refundPaymentMutation";
import { TextAreaInput } from "@/lib/Components/Form/Inputs/TextAreaInput";
import { CurrencyInput } from "@/lib/Components/Form/Inputs/CurrencyInput";
import { paymentRecordQuery } from "@/app/Payments/GraphQL/paymentRecordQuery";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { z } from "zod";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";

export function RefundPaymentDialog({ paymentId }: { paymentId: string }) {
  const { mutateAsync } = useGqlMutation(refundPaymentMutation);
  const { data } = useSuspenseGqlQuery(paymentRecordQuery, {
    id: paymentId,
  });
  const { close } = useDialogState();

  const validation = z.object({
    amount: z.number().min(1).max(data.payment.amount_paid),
    reason: z.string().min(0).max(256),
  });

  return (
    <BaseDialog title="Refund Payment">
      <GenericForm
        validationSchema={toFormikValidationSchema(validation)}
        initialValues={{
          amount: null!,
          reason: "",
        }}
        onSubmit={async (values) => {
          await mutateAsync({
            id: paymentId,
            reason: values.reason,
            amount: values.amount,
          });

          close();
        }}
      >
        <CurrencyInput
          name="amount"
          label="Amount"
          currency={data.payment.currency}
        />
        <TextAreaInput name="reason" label="Reason" className="col-span-full" />
        <DialogSubmitButton text={"Submit"} />
      </GenericForm>
    </BaseDialog>
  );
}
